import React, {useEffect, useState} from 'react';
import css from './SommlyScore.module.css';
import classNames from 'classnames';
import { AwardIcon, RedAwardIcon } from '../../../assets'
import { BottleRatingReview } from '../../../components/review/Bottle';
import {
  IoMdCheckmarkCircleOutline
} from 'react-icons/io';
import { IoCloseCircleOutline } from 'react-icons/io5';

const average = (...args) => args.reduce((a, b) => a + b) / args.length;

const SommlyScore = ({winery, reviews, awards}) => {
  const [openScore, setOpenScore] = useState(true);
  const [openAward, setOpenAward] = useState(false);
  const [quality, setQuality] = useState(0);
  const [variety, setVariety] = useState(0);
  const [venueAmbiance, setVenueAmbiance] = useState(0);
  const [foodOfferings, setFoodOfferings] = useState(0);
  const [customerService, setCustomerService] = useState(0);
  const [affordable, setAffordable] = useState(0);

  useEffect(() => {
    if(reviews.length > 0) {
      let tempQ = [];
      let tempV = [];
      let tempVA = [];
      let tempF = [];
      let tempC = [];
      let tempA = [];

      reviews.map(r => {
        tempQ = [...tempQ, r.quality]
        tempV = [...tempV, r.variety]
        tempVA = [...tempVA, r.venueAmbiance]
        tempF = [...tempF, r.foodOfferings]
        tempC = [...tempC, r.customerService]
        tempA = [...tempA, r.affordable]
      });

      const q = average(...tempQ);
      const v = average(...tempV);
      const va = average(...tempVA);
      const f = average(...tempF);
      const c = average(...tempC);
      const a = average(...tempA);


      setQuality(Number(q.toFixed(1)));
      setVariety(Number(v.toFixed(1)));
      setVenueAmbiance(Number(va.toFixed(1)));
      setFoodOfferings(Number(f.toFixed(1)));
      setCustomerService(Number(c.toFixed(1)));
      setAffordable(Number(a.toFixed(1)));
    }
  }, [reviews]);

  const handleOpenScore = () => {
    setOpenScore(true);
    setOpenAward(false);
  }
  const handleOpenAward = () => {
    setOpenScore(false);
    setOpenAward(true);
  }

  return (
    <div className={css.sommlyScoreWrapper}>
      <div className={css.sommlyScoreContainer}>

        <div className={css.scoreWrapper}>
          <div className={classNames(css.sommlyScore, openScore ? css.selected : "")} onClick={handleOpenScore}>
            <h2>Sommly Score</h2>
            <span style={{paddingLeft: "8px"}}>
              <BottleRatingReview
                score={winery?.score !== undefined ? winery?.score : 0}
                uniqId={winery?._id}
              />
            </span>
          </div>
          <div
            onClick={handleOpenAward}
            className={classNames(css.sommlyScoreAward, openAward ? css.awardSelected : "")}
          >
            <h2>Industry Awards</h2>
            {openAward ? <RedAwardIcon /> : <AwardIcon />}
          </div>
        </div>

        <div className={css.sommlyContentWrapper}>
          {openScore && !openAward ? (
            <div className={css.sommlyScoreContentWrapper}>
              <div>
                <div className={css.check}>
                  <div >
                    <h2>Reservations Required: </h2>
                  </div>
                  <div className={css.icons}>
                    {winery?.searchMeta.reservationsRequired ? (
                      <IoMdCheckmarkCircleOutline className={css.checkIcon}/>
                    ) : (
                      <IoCloseCircleOutline className={css.crossIcon} />
                    )}
                  </div>
                </div>
                <div className={css.check}>
                  <h2>Kid Friendly:</h2>
                  <div className={css.icons}>
                    {winery.searchMeta.kidFriendly ? (
                      <IoMdCheckmarkCircleOutline className={css.checkIcon} />
                    ) : (
                      <IoCloseCircleOutline className={css.crossIcon} />
                    )}
                  </div>
                </div>
                <div className={css.check}>
                  <h2>Dog Friendly:</h2>
                  <div className={css.icons}>
                    {winery.searchMeta.dogFriendly ? (
                      <IoMdCheckmarkCircleOutline className={css.checkIcon} />
                    ) : (
                      <IoCloseCircleOutline className={css.crossIcon} />
                    )}
                  </div>
                </div>
              </div>

              <div>
                <div className={css.check}>
                  <h2>Wine Quality: </h2>
                  <span className={css.sommlyScoreBottleReview}>
                    <BottleRatingReview score={quality} uniqId={winery?._id} />
                  </span>
                </div>
                <div className={css.check}>
                  <h2>Wine Variety: </h2>
                  <span className={css.sommlyScoreBottleReview}>
                    <BottleRatingReview score={variety} uniqId={winery?._id} />
                  </span>
                </div>
                <div className={css.check}>
                  <h2>Venue Ambiance: </h2>
                  <span className={css.sommlyScoreBottleReview}>
                    <BottleRatingReview score={venueAmbiance} uniqId={winery?._id} />
                  </span>
                </div>
              </div>
              <div>
                <div className={css.check}>
                  <h2>Affordable: </h2>
                  <span className={css.sommlyScoreBottleReview}>
                    <BottleRatingReview score={affordable} uniqId={winery?._id} />
                  </span>
                </div>
                <div className={css.check}>
                  <h2>Food Offerings: </h2>
                  <span className={css.sommlyScoreBottleReview}>
                    <BottleRatingReview score={foodOfferings} uniqId={winery?._id} />
                  </span>
                </div>
                <div className={css.check}>
                  <h2>Customer Service: </h2>
                  <span className={css.sommlyScoreBottleReview}>
                    <BottleRatingReview score={customerService} uniqId={winery?._id} />
                  </span>
                </div>
              </div>
            </div>
          ): null}
          {openAward && !openScore ? (
            <div className={css.sommlyAwardsContentWrapper}>
              {awards.length > 0 ? awards.map(award => (
                <div className={css.awardsWrapper}>
                  <div className={css.AwardIcon}>
                    <RedAwardIcon />
                  </div>
                  <div className={css.awardsInfo}>
                    <h4>{award?.position} - {award?.name} {award.year}</h4>
                    <p>{award.vintage} {award.vineyard} {award.varietal}</p>
                  </div>
                </div>
              )) : (
                <div className={css.noAwardWrapper}>
                  <RedAwardIcon />
                  <p>No awards available</p>
                </div>
              )}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default SommlyScore
